module.exports = __webpack_public_path__ + "static/media/location-blue.8d9b5698.svg";